// extracted by mini-css-extract-plugin
export default {"root":"game-descr_root__HL0Ml"};